// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  features: [],
}

export const mutations = {
  setFeatures(state, features) {
    state.features = features
  },
}

export const actions = {
  async fetchFeatures({ commit }) {
    const { data } = await mastertime.fetchFeatures()
    const features = data.data

    commit('setFeatures', features)
  },
}
